import React, { useEffect, useRef } from 'react'

const VideoEmbed = ({ embed, rate = 0.5625 }) => {
  const containerRef = useRef(null)
  const resizeTimerRef = useRef(null)

  useEffect(() => {
    if (!embed || !containerRef.current) {
      return null
    }

    // Находим iframe внутри контейнера
    const iframe = containerRef.current.querySelector('iframe')
    if (!iframe) {
      return null
    }

    // Функция изменения размера
    const resizeVideo = () => {
      if (!containerRef.current) {
        return null
      }

      // Используем getBoundingClientRect для точной ширины
      const rect = containerRef.current.getBoundingClientRect()
      const containerWidth = rect.width || containerRef.current.offsetWidth || 640
      const height = Math.round(containerWidth / rate)

      iframe.style.width = '100%'
      iframe.style.height = height + 'px'
      iframe.style.display = 'block'
      iframe.style.border = 'none'

      iframe.setAttribute('width', '100%')
      iframe.setAttribute('height', height)
    }

    // Несколько попыток установить размеры
    const attemptResize = (attempt = 0) => {
      if (attempt >= 5) {
        return
      } // максимум 5 попыток

      requestAnimationFrame(() => {
        const rect = containerRef.current?.getBoundingClientRect()
        if (rect && rect.width > 0) {
          resizeVideo()
        } else {
          // Если ширина 0, пробуем снова через 100ms
          setTimeout(() => attemptResize(attempt + 1), 100)
        }
      })
    }

    attemptResize()

    const handleResize = () => {
      clearTimeout(resizeTimerRef.current)
      resizeTimerRef.current = setTimeout(() => {
        requestAnimationFrame(resizeVideo)
      }, 200)
    }

    window.addEventListener('resize', handleResize)

    // Следим за изменением размера контейнера
    const resizeObserver = new ResizeObserver(() => {
      resizeVideo()
    })

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current)
    }

    return () => {
      window.removeEventListener('resize', handleResize)
      resizeObserver.disconnect()
      clearTimeout(resizeTimerRef.current)
    }
  }, [embed, rate])

  if (!embed) {
    return null
  }

  return <div ref={containerRef} className="video-embed" dangerouslySetInnerHTML={{ __html: embed }} />
}

export default VideoEmbed
